import { createContext, useContext, useState } from "react";

const pharmacyContext = createContext();

export const PharmacyProvider = (props) => {
	const [pharmacyPOS, setPharmacyPOS] = useState(() => {
			const saved = localStorage.getItem('currentPharmacyPOS');
			return saved ? JSON.parse(saved) : null;
		});

		return (
			<pharmacyContext.Provider value={{ ...props, pharmacyPOS, setPharmacyPOS}}>
				{props.children}
			</pharmacyContext.Provider>
		)
}

export const usePharmacy = () => useContext(pharmacyContext);